<template>
  <v-dialog
    class="dialog-box-custom"
    v-model="isOpen"
    width="32rem"
    :persistent="isPersistent"
    @keydown.prevent.enter="executeMainAction"
  >
    <v-card class="card-custom" :style="cardStyle">
      <div class="title-custom" v-if="title">
        <span>{{ title }}</span>
      </div>

      <div class="content-custom">
        <slot name="content"></slot>
      </div>

      <div
        class="action-buttons-div-custom" v-if="mainActionLabel || extraActionLabel"
      >
        <slot name="actionButtons"></slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogContent",

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    isOpen: {
      type: Boolean,
      required: true,
    },

    onClose: Function,

    /**
     * Title of the dialog box.
     */
    title: {
      type: String,
      required: false,
    },
    /**
     * Main text inside the dialog box
     */
    content: {
      type: String,
      required: false,
    },
    /**
     * Label of the main action button
     */
    mainActionLabel: {
      type: String,
      required: false,
    },
    /**
     * Label of the secondary action button
     */
    secondaryActionLabel: {
      type: String,
      required: false,
    },
    /**
     * Label of the extra action button
     */
    extraActionLabel: {
      type: String,
      required: false,
    },

    /**
     * Defines if the dialog box can be closed by clicking outside of it
     */
    isPersistent: {
      type: Boolean,
      default: false,
    },

    /**
     * Determines if the second button is loading and the main one is disabled
     */
    loading: {
      type: Boolean,
      default: false,
    },

    /**
     * Determines if the secondary button is disabled
     */
    secondaryActionDisable: {
      type: Boolean,
      default: true,
    },
    /**
     * Determines if the extra button is disabled
     */
    extraActionDisable: {
      type: Boolean,
      default: true,
    },

    cardStyle: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {

    };
  },

  watch: {
    isOpen(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.onClose(); // Call the onClose callback
      }
    },
  },

  methods: {
    /**
     * Send an event to the parent to execute the main action.
     */
    executeMainAction() {
      this.$emit('mainAction');
      this.onClose();
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeSecondaryAction() {
      this.isOpen = false
      this.$emit("secondaryAction");
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeExtraAction() {
      this.isOpen = false
      this.$emit("extraAction");
    },
  },
};
</script>

<style>
/* .dialog-box-custom{
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #fafbfc;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; */
/* } */

.v-dialog {
  border-radius: 0.75rem !important;
}

.card-custom{
  height: 18rem !important;
  padding: 1.6rem 1.62rem 1.6rem 1.62rem;
}

.title-custom{
}

.content-custom{
  height: 100%;
  /* display: flex !important; */
  /* justify-content: flex-start !important; */
}

.action-buttons-div-custom{
  max-height: 15%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Molecules/DialogContent.vue